import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let DataMining = class DataMining extends Vue {
    objectInfo;
    isStartSelection = true;
    deleteImageUrl = require('@blade-sxp/search-center/assets/images/del.png');
    startSelection() {
        this.isStartSelection = !this.isStartSelection;
        this.$emit('startSelection', this.isStartSelection);
    }
    // 删除事件
    deleteImg(imageId, item) {
        this.$emit('delete-img', imageId, item);
    }
    // 清空全部脑图
    clearAlltrack() {
        this.$emit('clear-alltrack');
    }
    // 去三级页面 脑图
    goRelation() {
        this.$router.push('/search/searchPage/relation');
    }
};
__decorate([
    Prop({})
], DataMining.prototype, "objectInfo", void 0);
DataMining = __decorate([
    Component({
        name: 'right',
        components: { BlurPicture },
        i18n: {
            messages: {
                en: {
                    ok: 'OK',
                },
                zh: {
                    ok: '确定',
                },
            },
        },
    })
], DataMining);
export default DataMining;
